import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import titleReducer from "./features/titleSlice";

export default configureStore({
    reducer: {
        title: titleReducer,
    },
    middleware: getDefaultMiddleware({
        serializableCheck: false
    }),
});